import { render, staticRenderFns } from "./hs-color-simple.vue?vue&type=template&id=3afc14b9&scoped=true&"
import script from "./hs-color-simple.vue?vue&type=script&lang=js&"
export * from "./hs-color-simple.vue?vue&type=script&lang=js&"
import style0 from "./hs-color-simple.vue?vue&type=style&index=0&id=3afc14b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc14b9",
  null
  
)

export default component.exports